(function initMainProduct() {
  const section = document.querySelector('.pdp-product[data-product-detail]');
  if (!section) return;

  const jsonEl = section.querySelector('[data-product-json]');
  const form = section.querySelector('[data-product-form]');
  const variantInput = section.querySelector('[data-variant-id]');
  if (!jsonEl || !variantInput) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  const moneyFormat = section.dataset.moneyFormat || '${{amount}}';
  const variants = product.variants || [];
  const picker = section.querySelector('[data-variant-picker]');

  const formatMoney = (cents) => {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  };

  const priceCurrent = section.querySelector('[data-pdp-price-current]');
  const priceCompare = section.querySelector('[data-pdp-price-compare]');
  const priceBadge = section.querySelector('[data-pdp-price-badge]');
  const addLabel = section.querySelector('[data-add-label]');
  const addBtn = section.querySelector('[data-add-to-cart]');
  const zoomLink = section.querySelector('[data-pdp-zoom]');

    const getSelectedOptions = () => {
      if (!picker) return [];
      const options = new Array(product.options.length).fill(null);
      picker.querySelectorAll('select[data-option-index]').forEach((select) => {
        const idx = parseInt(select.dataset.optionIndex, 10);
        if (!Number.isNaN(idx)) {
          const selected = select.options[select.selectedIndex];
          options[idx] = selected?.dataset.optionValue || selected?.value;
        }
      });
      picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        if (!Number.isNaN(idx)) options[idx] = input.dataset.optionValue;
      });
      return options;
    };

  const findVariant = (options) =>
    variants.find((v) => v.options.every((opt, i) => opt === options[i]));

  const updateOptionLabels = (options) => {
    if (!picker) return;
    options.forEach((value, index) => {
      const el = picker.querySelector(`[data-option-selected="${index}"]`);
      if (el && value) el.textContent = value;
    });
  };

  const setSlide = (mediaId) => {
    section.querySelectorAll('[data-pdp-slide]').forEach((slide) => {
      const match = String(slide.dataset.mediaId) === String(mediaId);
      slide.hidden = !match;
      slide.classList.toggle('is-active', match);
    });
    section.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
      thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId));
    });
    const activeSlide = section.querySelector('[data-pdp-slide].is-active img[data-pdp-image]');
    if (zoomLink && activeSlide) {
      zoomLink.href = activeSlide.currentSrc || activeSlide.src;
    }
  };

  const updateVariant = () => {
    const options = getSelectedOptions();
    const variant = findVariant(options) || variants[0];
    if (!variant) return;

    variantInput.value = variant.id;
    updateOptionLabels(options);

    const price = variant.price;
    const compareAt = variant.compare_at_price || 0;
    const onSale = compareAt > price;
    const percentOff = onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

    if (priceCurrent) priceCurrent.textContent = formatMoney(price);
    if (priceCompare) {
      priceCompare.textContent = formatMoney(compareAt);
      priceCompare.hidden = !onSale;
    }
    if (priceBadge) {
      if (onSale && percentOff > 0) {
        priceBadge.textContent = `${percentOff}% OFF`;
        priceBadge.hidden = false;
      } else {
        priceBadge.hidden = true;
      }
    }

    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = addBtn.dataset.labelAdd || 'ADD TO CART';
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Sold out';
      }
    }

    const mediaId = variant.featured_media?.id || variant.featured_image?.id;
    if (mediaId) setSlide(mediaId);
  };

  section.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => setSlide(thumb.dataset.mediaId));
  });

  const qtyInput = section.querySelector('[data-qty-input]');
  section.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1 || 1);
  });
  section.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) + 1 || 2);
  });

    if (picker) {
      picker.addEventListener('change', (event) => {
        if (event.target.matches('select[data-option-index]')) {
          const idx = parseInt(event.target.dataset.optionIndex, 10);
          const selected = event.target.options[event.target.selectedIndex];
          const value = selected?.dataset.optionValue || selected?.value;
          const label = picker.querySelector(`[data-option-selected="${idx}"]`);
          if (label && value) label.textContent = value;
        }
        updateVariant();
      });
    }

  section.querySelector('[data-buy-now]')?.addEventListener('click', async () => {
    if (!form) return;
    const btn = section.querySelector('[data-buy-now]');
    if (btn) btn.disabled = true;
    try {
      const formData = new FormData(form);
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      window.location.href = '/checkout';
    } catch (e) {
      if (btn) btn.disabled = false;
    }
  });

  if (addBtn) {
    addBtn.dataset.labelAdd = addLabel?.textContent?.trim() || 'ADD TO CART';
  }

  updateVariant();
})();
